import { render, staticRenderFns } from "./AddNewResponses.vue?vue&type=template&id=9185f438&"
import script from "./AddNewResponses.vue?vue&type=script&lang=js&"
export * from "./AddNewResponses.vue?vue&type=script&lang=js&"
import style0 from "./AddNewResponses.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports